// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BodyLink[data-v-2aac376d]{color:#00f;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
